import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { MemberService } from '@services/member.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { fadeInUpOnEnterAnimation,rollInOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-myactivity',
  templateUrl: './myactivity.component.html',
  styleUrls: ['./myactivity.component.sass'],
  animations:[
    rollInOnEnterAnimation({anchor:'myactivity', delay: 0})
  ]
})
export class MyactivityComponent implements OnInit {
  dataLoding = true;
  component='b';
  application="activities";
  response:any=[];
  total_record=0;
  pageCounter = 1;
  pageno = 1;
  params:any=[];
  rows = 1;
  constructor(private route: ActivatedRoute, private _global: GlobalService, private router: Router, private _memberService: MemberService) {
    this.rows = this._global.ROWS;
    let p = {
      component: this.component,
      application: this.application,
      sortOrder: 'desc',
      sortString: 'createdTime',
      createdBy:this._global.getSessionVal('id'),
      start: 0,
      rows: this.rows
    };
   this._memberService.activities(p).subscribe(
      data => {
        this.dataLoding = false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
        this.params = this._global.getVal(data, 'request', '');
        this.response = data["response"]["docs"];
        this.total_record = this._global.getVal(data, 'response.numFound', '0');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });


  }

  ngOnInit() {
  }

  gotoProfile(obj){
    let id=this._global.getVal(obj,'createdBy','');
    if(this._global.isOwner(id)){
      this.router.navigate(['/my']);
    }else{
      this.router.navigate(['/view/member'], { queryParams: { 'id' : id } });
    }
  }
  onScrollDown() {
  
      this.dataLoding = true;
      if (this.total_record <= this.pageCounter * this.rows) {
        this.dataLoding = false;
      } else {
        let p = this._global.generateParams(this.params, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._memberService.activities(p).subscribe(
          data => {
            this.dataLoding = false;
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.response = this.response.concat(data["response"]["docs"]);
           
              this.pageCounter += 1;
              this.params = this._global.getVal(data, 'request', '');
            }else{
              this.dataLoding = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });
        //  console.log('scrolled down!!', ev);

      }
    
  }
  replaceDescription (obj) {
    let str = this._global.getVal(obj, 'description', '');
    let mediaName = this._global.getVal(	obj, 'mediaName', '');
    let entityName = this._global.getVal(obj,	'entityName', '');
		str = str.replace(/\${mediaName}/g,  mediaName );
		str = str.replace(/\${entityName}/g, entityName);
		return str;

	}

}
